import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { SoundService } from 'app/services/sound-service.service';

@Component({
  selector: 'app-buton-sound',
  standalone: true,
  imports: [
    CommonModule
  ],
  templateUrl: './buton-sound.component.html',
  styleUrls: ['./buton-sound.component.scss']
})
export class ButonSoundComponent {
  soundEnabled$;

  constructor(private soundService: SoundService) {
    this.soundEnabled$ = this.soundService.sound$;
  }

  toggleSound() {
    this.soundService.toggleSound();
  }
}
